export default "__VITE_ASSET__Jghgg_4T__"